// extracted by mini-css-extract-plugin
module.exports = {"gx-main-content-wrapper":"MainApp_gx-main-content-wrapper__tdILz"};